var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseCricle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M6.026 11.972c3.25 0 5.936-2.687 5.936-5.936 0-3.25-2.687-5.937-5.942-5.937C2.77.1.09 2.786.09 6.036c0 3.249 2.687 5.936 5.936 5.936zM3.86 8.592c-.22 0-.397-.171-.397-.384 0-.113.042-.201.119-.278l1.894-1.894-1.894-1.894c-.071-.071-.119-.166-.119-.272 0-.22.178-.385.397-.385.106 0 .195.041.272.118L6.02 5.491l1.9-1.888c.083-.089.172-.124.278-.124.22 0 .39.172.39.385 0 .106-.035.195-.118.278L6.576 6.036l1.888 1.888c.077.077.119.171.119.284 0 .213-.172.385-.39.385-.113 0-.208-.048-.285-.119L6.02 6.586 4.144 8.474c-.077.077-.178.119-.284.119z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCricle);
export default __webpack_public_path__ + "static/media/close-cricle.1b442c1d06606ab5f67353eb294c158c.svg";
export { ForwardRef as ReactComponent };